/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ExcelFormulaValidationIssue = {
    formula_index: number;
    severity: ExcelFormulaValidationIssue.severity;
    code: string;
    message: string;
    function_name?: (string | null);
    arg_index?: (number | null);
};

export namespace ExcelFormulaValidationIssue {

    export enum severity {
        WARNING = 'warning',
        ERROR = 'error',
    }


}

